import compareVersions from 'compare-versions';

var Version = /** @class */ (function () {
    function Version(version) {
        if (version === void 0) { version = '0.0.0'; }
        this.val = version.toString();
    }
    Version.prototype.lte = function (version) {
        return compareVersions.compare(this.val, version, '<=');
    };
    Version.prototype.gte = function (version) {
        return compareVersions.compare(this.val, version, '>=');
    };
    Version.prototype.lt = function (version) {
        return compareVersions.compare(this.val, version, '<');
    };
    Version.prototype.gt = function (version) {
        return compareVersions.compare(this.val, version, '>');
    };
    Version.prototype.eq = function (version) {
        return compareVersions.compare(this.val, version, '=');
    };
    Version.prototype.compare = function (version, operator) {
        if (operator === void 0) { operator = '='; }
        return compareVersions.compare(this.val, version, operator);
    };
    Version.prototype.toString = function () {
        return this.val;
    };
    return Version;
}());

function defaultApp() {
    return {
        name: undefined,
        version: new Version(),
        isJike: false,
        isWeChat: false,
        isWeibo: false,
        isQQ: false,
        isCosmos: false,
    };
}
function getApp(source) {
    var regexpMatch = null;
    var app = defaultApp();
    switch (true) {
        case (regexpMatch = /jike\/([\d\w\.]+)/i.exec(source)) !== null:
            app.name = 'Jike';
            app.isJike = true;
            app.version = new Version(regexpMatch && regexpMatch[1] ? regexpMatch[1] : undefined);
            break;
        case (regexpMatch = /MicroMessenger\/([\d\w\.]+)/i.exec(source)) !== null:
            app.name = 'WeChat';
            app.isWeChat = true;
            app.version = new Version(regexpMatch && regexpMatch[1] ? regexpMatch[1] : undefined);
            break;
        case /Weibo/i.test(source):
            app.name = 'Weibo';
            app.isWeibo = true;
            break;
        case /QQ/i.test(source):
            app.name = 'QQ';
            app.isQQ = true;
            break;
        case (regexpMatch = /Xiaoyuzhou\/([\d\w\.]+)/i.exec(source)) !== null:
            app.name = 'Cosmos';
            app.isCosmos = true;
            app.version = new Version(regexpMatch && regexpMatch[1] ? regexpMatch[1] : undefined);
            break;
    }
    return app;
}

function defaultBrowser() {
    return {
        name: undefined,
        version: new Version(),
        isX5: false,
        isSafari: false,
        isChrome: false,
    };
}
function getBrowser(source) {
    var browser = defaultBrowser();
    switch (true) {
        case /MQQBrowser\/([\d\.]+)/i.test(source):
            browser.name = 'X5';
            browser.isX5 = true;
            break;
        case /Chrome\/([\d.]+)/.test(source):
            browser.name = 'Chrome';
            browser.isChrome = true;
            break;
        case /Firefox\/([\d.]+)/.test(source):
            browser.name = 'Firefox';
            break;
        case /(iPhone|iPod|iPad).*AppleWebKit(.*Safari)/.test(source):
            browser.name = 'Safari';
            browser.isSafari = true;
            break;
        case /Safari/.test(source):
            browser.name = 'Safari';
            browser.isSafari = true;
            break;
    }
    return browser;
}

function defaultDevice() {
    return {
        type: '',
        isDesktop: false,
        isMobile: false,
        isTablet: false,
        statusBarHeight: undefined,
        prefersColorScheme: undefined,
    };
}
function getDevice(source, isJike) {
    var device = defaultDevice();
    var statusBarHeightInfo = /StatusBarHeight\/([\d\w]+)/i.exec(source);
    if (typeof window !== 'undefined') {
        var pixelRatio = window.devicePixelRatio || 1;
        device.statusBarHeight =
            statusBarHeightInfo && statusBarHeightInfo[1]
                ? parseInt(statusBarHeightInfo[1], 10) / pixelRatio
                : undefined;
    }
    var prefersColorSchemeInfp = /PrefersColorScheme\/([\d\w]+)/i.exec(source);
    device.prefersColorScheme =
        prefersColorSchemeInfp && prefersColorSchemeInfp[1]
            ? prefersColorSchemeInfp[1]
            : undefined;
    switch (true) {
        case /iPhone|iPad|iPod|Android/i.test(source):
            device.type = 'Mobile';
            device.isMobile = true;
            break;
        case /ipad|tablet/i.test(source):
            device.type = 'Tablet';
            device.isTablet = true;
            break;
        case /Mac|Windows/i.test(source):
            device.type = 'Desktop';
            device.isDesktop = true;
            break;
    }
    return device;
}

function defaultOS() {
    return {
        name: undefined,
        version: new Version(),
        isAndroid: false,
        isiOS: false,
    };
}
function getOS(source) {
    var regexpMatch = null;
    var os = defaultOS();
    switch (true) {
        case (regexpMatch = /android ([\d\w\.]+)/i.exec(source)) !== null:
            os.isAndroid = true;
            os.name = 'Android';
            os.version = new Version(regexpMatch && regexpMatch[1] ? regexpMatch[1] : undefined);
            break;
        case (regexpMatch = /[iPhone|iPad|iPod].*OS ([\d_]+)/i.exec(source)) !== null:
            os.isiOS = true;
            os.name = 'iOS';
            os.version = new Version(regexpMatch && regexpMatch[0] ? regexpMatch[1].replace(/_/g, '.') : undefined);
            break;
    }
    return os;
}

function defaultEnv() {
    return {
        app: defaultApp(),
        os: defaultOS(),
        browser: defaultBrowser(),
        bot: {
            isBot: false,
        },
        device: defaultDevice(),
        source: '',
    };
}
/**
 * @params rawSource useragent字符串
 * @description 使用 _parseUserAgent_ 解析 _rawSource_
 * @returns 返回一个 _Env_ 实例
 */
function parseUserAgent(rawSource) {
    if (typeof rawSource !== 'string') {
        throw new Error('Invalid User Agent Source');
    }
    var source = rawSource.trim();
    var app = getApp(source);
    var browser = getBrowser(source);
    var device = getDevice(source, app.isJike);
    var os = getOS(source);
    return {
        app: app,
        browser: browser,
        device: device,
        source: source,
        bot: {
            isBot: /bot|googlebot|crawler|spider|robot|crawling/i.test(source),
        },
        os: os,
    };
}
var envInstance;
var hasNavigator = typeof navigator !== 'undefined';
/**
 * @description 使用 _parseUserAgent_ 解析 _navigator.userAgent_ 将结果作为单例返回，该方法仅会解析一次 _Useragent_
 * @returns 返回唯一的 _Env_ 实例
 */
var getEnv = function () {
    if (!envInstance) {
        envInstance = hasNavigator ? parseUserAgent(navigator.userAgent) : defaultEnv();
    }
    return envInstance;
};

export { defaultEnv, getApp, getDevice, getEnv, getOS, parseUserAgent };
